export const Colors = {
    primary: "#f7a600",
    secondary: "#e94f2d",
    danger: "#FB5607",
    attention: "#ffcc00",
    okay: "#28B6A6",
    primaryShade1: "#fbd180",
    primaryShade2: "#c98700",
    replacement: "#b52513",
    background: "#F9F9F9",
    released: "#29FF00",
};
